(function() {
    angular.module('tmx-app').controller('locationCtrl', ['$scope', 'menu','LocationService', '$mdDialog', '$state', '$mdSidenav', 'lookupService','tmxUtility','$timeout','TmxDialogService', 

        function LocationCtrl($scope,menu, LocationService, $mdDialog, $state, $mdSidenav, lookupService,tmxUtility,$timeout,TmxDialogService) {
            var locationVM = this;
            locationVM.nav = "SearchSideNav";
            var exists = tmxUtility.exists;
            locationVM.checkPermission = tmxUtility.checkPermission;
            var findItems=tmxUtility.findItems;
            var copy;
            copy = tmxUtility.copy;
            locationVM.menu=menu;

            locationVM.editPermission=locationVM.checkPermission("Private.Masterdata.Location","Edit");
            locationVM.viewPermission=locationVM.checkPermission("Private.Masterdata.Location","View");

            locationVM.FilteredValue={
                LocationName:false,
                LocationCode:false,
                ParentLocationId:false,
                LocationTypeLkpId:false

            }
    ///////////////////FUNCTIONS////////////////////////
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            function AddHasChildrenProperty(response){
                var flags = [], ParentIds = [], l = response.Data.length,finalData=[];
                for(var i=0; i<l; i++) {
                    if( flags[response.Data[i].ParentLocationId]) continue;
                    flags[response.Data[i].ParentLocationId] = true;
            //if(response.Data[i].ParentLocationId)
                    ParentIds.push(response.Data[i].ParentLocationId);
                }
                locationVM.gridData=response;
                response.Data.forEach(node=>{
                    node.ParentLocationName = LocationService.getParentName(node.ParentLocationId);
                    node.LocationTypeName = LocationService.getLookupName(node.LocationTypeLkpId);
                    if(ParentIds.includes(node['LocationId'])){
                        node['hasChildren']=true;
                    }
                    else{
                        node['hasChildren']=false;
                    }
                    finalData.push(node)
                })
                locationVM.gridData.Data=finalData;
            
            }
            var FirstTimeLoad=0;
            function FirstTimeLoadAddress(o) {

         // get active top parents only
                LocationService.getActiveTopParent(locationVM.gridData).then(function (response) {
                    if(FirstTimeLoad==0) {
                        FirstTimeLoad++;
                    }
                    o.success(response);
                });

            }
            function ChildLoading(o , parentLocationId){

         // get all active child Locations
                LocationService.getSpecificParentChild(locationVM.gridData , parentLocationId).then(function (response) {
             // locationVM.o=o;
                    o.success(response);
                });
            }
            locationVM.checkAddDisabled = function(){
                if($mdSidenav(locationVM.nav).isOpen()){
                    return true;
                }
                else{
                    return false;
                }
            };
            locationVM.success=function(promise){
                if (promise.read == true) {
                    locationVM.mainGridOptions.dataSource.transport.read(promise);
                }
                else {
                    locationVM.container.locationTree.dataSource.transport.read();
                }
      //locationVM.toggleSearch(locationVM.nav);
            };
            locationVM.isFiltered=function(fieldName){
                var filtered=false;

                if(fieldName=="LocationTypeLkpId") {
                    filtered=locationVM.FilteredValue.LocationTypeLkpId;
                }
                else if(fieldName=="LocationName") {
                    filtered=locationVM.FilteredValue.LocationName;
                }

                else if(fieldName=="LocationCode") {

                    filtered=locationVM.FilteredValue.LocationCode;
                }
                else if (fieldName=="ParentLocationId") {
                    filtered= filtered=locationVM.FilteredValue.ParentLocationId;
                }

                return filtered;
            }

            locationVM.setFiteredTrue=function(key) {
                if(key=="LocationTypeLkpId") {
                    locationVM.FilteredValue.LocationTypeLkpId=true;
                }
                else if(key=="LocationName") {
                    locationVM.FilteredValue.LocationName=true;
                }

                else if(key=="LocationCode") {

                    locationVM.FilteredValue.LocationCode=true;
                }
                else if (key=="ParentLocationId") {
                    locationVM.FilteredValue.ParentLocationId=true;
                }
            }


            locationVM.setFiteredFalse=function(key) {
                if(key=="LocationTypeLkpId") {
                    locationVM.FilteredValue.LocationTypeLkpId=false;
                }
                else if(key=="LocationName") {
                    locationVM.FilteredValue.LocationName=false;
                }

                else if(key=="LocationCode") {

                    locationVM.FilteredValue.LocationCode=false;
                }
                else if (key=="ParentLocationId") {
                    locationVM.FilteredValue.ParentLocationId=false;
                }
            }


            locationVM.onChildState = function() {
                if ($state.current.name.indexOf(".add") > 0 || $state.current.name.indexOf(".edit") > 0) return true;
            }
            locationVM.new = function() {
      //locationVM.searchClear = false;
                if (angular.isDefined($state.data.parent)) {
                    delete $state.data.parent;
                }
                $state.go($state.current.name + ".add");
            };
            locationVM.clickEdit = function(item) {
      //locationVM.searchClear = false;
                $state.data.parent = {
                    id: item.ParentLocationId,
                    name: item.ParentLocationName
                };
                $state.go($state.current.name + ".edit", {
                    "Id": item.LocationId
                });
            }
      
            locationVM.clickView = function (item) {   
      //locationVM.searchClear = true;
                $state.data.info = true;         
                $state.go($state.current.name+".edit",{"Id":item.LocationId});
            }

            locationVM.clickParent = function(item) {
                $state.data.parent = {
                    id: item.LocationId,
                    name: item.LocationName
                };
                $state.go($state.current.name + ".add");
            }
            var deleteConfirm = function(tid, ev) {
                var confirm = $mdDialog.confirm()
                    .clickOutsideToClose(true)
                    .title('Delete Location ' + tid.LocationName + " ?")
                    .textContent('Are you sure you want to delete this Location?')
                    .ariaLabel('Lucky day')
                    .targetEvent(ev)
                    .ok('Yes')
                    .cancel('Cancel');
                $mdDialog.show(confirm).then(function() {
                    DeleteLocation(tid);
                });
            };
            var DeleteLocation = function(tid) {
                tid.$remove().then(function(result) {
                    if (result)
                        locationVM.gridData.remove(tid);
                });
            };
            locationVM.clickDelete = function(item) {
                deleteConfirm(item);
            };
            locationVM.isStatusActive = function(dataitem) {
                if (dataitem.EffectiveEndDate > locationVM.date) {
                    return true;
                }
                else {
                    return false;
                }          
            }
            locationVM.onClick = function(e, dataItem) {
                var element = $(e.currentTarget);
                var checked = element.is(':checked');
                var row = element.closest("tr");
                if (checked) {
                    row.addClass("k-state-selected");
                    locationVM.addToBulk(dataItem);
                }
                else {
                    row.removeClass("k-state-selected");
                    locationVM.removeFromBulk(dataItem);
                }
            };
            locationVM.addToBulk = function(dataItem) {
                locationVM.bulk.push(dataItem);
            };
            locationVM.removeFromBulk = function(dataItem) {
                for (var i = locationVM.bulk.length - 1; i >= 0; i--) {
                    if (locationVM.bulk[i].CompanyId === dataItem.CompanyId) {
                        locationVM.bulk.splice(i, 1);
                    }
                }
            };
            locationVM.bulkDelete = function() {
                var confirm = $mdDialog.confirm()
                    .title('Bulk Delete')
                    .textContent('Are you sure you want to delete ' + locationVM.bulk.length + ' companies?')
                    .ariaLabel('Lucky day')
        // .targetEvent(ev)
                    .ok('Yes')
                    .cancel('Cancel');
                $mdDialog.show(confirm).then(function() {
                    LocationService.bulkDelete(locationVM.bulk);
                }, function() {
                });
            };
            locationVM.toggleSearch = function() {
                if (locationVM.searchSideNavActive) {
        // locationVM.searchData = {};
                    locationVM.searchSideNavActive = false;
                }
                else
                    locationVM.searchSideNavActive = true;
                locationVM.toggle('SearchSideNav');
            }
            locationVM.toggleExport = function() {
                if (locationVM.exportSideNavActive)
                    locationVM.exportSideNavActive = false;
                else
                    locationVM.exportSideNavActive = true;
                locationVM.toggle('ExportSideNav');
            }
            locationVM.toggle = function(navID) {
                $mdSidenav(navID)
                    .toggle()
                    .then(function() {});
            };
            locationVM.isOpen = function(navID) {
                return $mdSidenav(navID).isOpen();
            };
            locationVM.filt = {};

            locationVM.search = function() {
                var calls = [];
                for (var key in locationVM.searchData) {
                    if (locationVM.searchData.hasOwnProperty(key)) {

                        if(key=="Status") {
                            if(locationVM.searchData[key]=="active") {
                                calls.push({
                                    field: "EffectiveEndDate",
                                    operator: "gte",
                                    value: locationVM.date
                                });
                                calls.push({
                                    field: "EffectiveStartDate",
                                    operator: "lte",
                                    value: locationVM.date
                                });
                            }
                            else if(locationVM.searchData[key]=="inactive") {
                                calls.push({
                                    field: "EffectiveEndDate",
                                    operator: "lt",
                                    value: locationVM.date
                                });
                            }
                            else if(locationVM.searchData[key]=="pending") {
                                calls.push({
                                    field: "EffectiveStartDate",
                                    operator: "gt",
                                    value: locationVM.date
                                });  
                    
                    // locationVM.model.data.filter = filt;
                            }
                        }
                        else {
                            var operator = "contains";
                            var val = locationVM.searchData[key];
                            for (var i = locationVM.cols.length - 1; i >= 0; i--) {
                    
                                if(key==locationVM.cols[i].field) {
                                    if(locationVM.cols[i].type=="number") {
                                        operator="gte";
                                    }
                                    else if(locationVM.cols[i].type=="select" && angular.isDefined(locationVM.cols[i].isNumber)) {
                                        if(locationVM.cols[i].isNumber==true) {
                                            operator="eq";
                                            val = Number(locationVM.searchData[key]);
                                        }
                                    }
                                }
                            }
                            if(locationVM.searchData[key]!=null && locationVM.searchData[key]!="") {
                                calls.push({
                                    field: key,
                                    operator: operator,
                                    value: val
                                });
                                locationVM.setFiteredTrue(key);
                            }
                            else{
                                locationVM.setFiteredFalse(key);
                            }
                        }


          // calls.push({
          //   field: key,
          //   operator: operator,
          //   value: locationVM.searchData[key]
          // });
                    }
                }
                locationVM.filt = {
                    filters: calls,
                    logic: "and"
                };
                locationVM.searchObject.data.filter = locationVM.filt;
      // locationVM.o.data.filter = locationVM.filt;
     
      // locationVM.container.locationTree.dataSource.transport.read(locationVM.o);
                locationVM.container.locationTree.dataSource.filter(locationVM.filt);
                locationVM.prevReq = locationVM.container.locationTree.dataSource.read();


            };
            locationVM.clear = function(navID) {
                locationVM.searchData = {};
                locationVM.toggleSearch(navID);
            };
            locationVM.clearSideNav = function() {
                locationVM.searchData = {};
                callSearch();
            };
            locationVM.addChild = function() {
            };
            locationVM.clickDeactivate = function(item) {

                var diagConfig={
                    action:"Deactivate",
                    entity:"Location",
                    entityname:item.LocationName,
                    details:[
                        {value:item.LocationName,label:"Location Name"},
                        {value:item.LocationCode, label:"Location Code"}
                    ],
                    options:[
                        {label:"Deactivate",value:true,class:"md-warn"},
                        {label:"Cancel",value:false,class:"md-primary"}
                    ]
                };
                function callback(ok) {
                    if(ok){
                        locationVM.Deactivate(item);
                    }
                }
                var locationDeactivateDialog=new TmxDialogService.confirmDialog(diagConfig,callback);

                locationDeactivateDialog.show();

            };
            locationVM.clickActivate = function(item) {
                var diagConfig={
                    action:"Activate",
                    entity:"Location",
                    entityname:item.LocationName,
                    details:[
                        {value:item.LocationName,label:"Location Name"},
                        {value:item.LocationCode, label:"Location Code"}
                    ],
                    options:[
                        {label:"Activate",value:true,class:"md-warn"},
                        {label:"Cancel",value:false,class:"md-primary"}
                    ]
                };
                function callback(ok) {
                    if(ok){
                        locationVM.Activate(item);
                    }
                }
                var locationActivateDialog=new TmxDialogService.confirmDialog(diagConfig,callback);

                locationActivateDialog.show();
      //var confirm = $mdDialog.confirm()
      //.title('Activate Location '+item.LocationName+" ?")
      //.textContent('Are you sure you want to activate this Location?')
      //.ariaLabel('Activate Location')
      //.clickOutsideToClose(true)
      //.ok('Yes')
      //.cancel('Cancel');
      //$mdDialog.show(confirm).then(
      //  function() {
      //  locationVM.Activate(item);
      //  }, function() {
      //  }
      //);
            };
            locationVM.Deactivate = function(item) {
                item.$deactivate(item.LocationId).then(function() {
                    locationVM.container.locationTree.dataSource.read();
                });
            };
    //locationVM.Deactivate = function(item) {
    //  LocationService.prototype.$deactivate(item.LocationId).then(function(promise) {
    //    locationVM.container.locationGrid.dataSource.read();
    //  });
    //};
            locationVM.Activate = function(item) {
                item.$activate(item.LocationId).then(function() {
                    locationVM.container.locationTree.dataSource.read();
                });
            };
    ////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            locationVM.valueChange=function(value){
           

                if(angular.isDefined(value)){
                    if(value.length==0 || value.length>2){
                        callSearch();

                    }
                }
            };
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            locationVM.valueChangeSelect=function(value){
                if(angular.isDefined(value)){
                    callSearch();

                }
            };
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            function callSearch(){
             
                if(angular.isDefined(locationVM.prevTimeout)){
                    $timeout.cancel(locationVM.prevTimeout);
                    delete locationVM.prevTimeout;
                }
                cancelLastRequest();
                locationVM.prevTimeout=$timeout(locationVM.search,500);
            }
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            function cancelLastRequest(){
                if(angular.isDefined(locationVM.prevReq) && angular.isDefined(locationVM.prevReq.cancel)){
                    locationVM.prevReq.cancel();
                    delete locationVM.prevReq;
                }
            }
 ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    //////////////////////CODE//////////////////////////
            locationVM.query = "Location";
            locationVM.LocationService = LocationService;
            locationVM.cols = LocationService.gridColumn;
            locationVM.date = new Date().toJSON();
            lookupService.getLocationTypes().then(function(types) {
                locationVM.locationTypeLookup = types;
            });
            locationVM.gridData = new kendo.data.ObservableArray([
            ]);
            $state.data = {
                gridData: locationVM.gridData
            };
            $scope.location = LocationService;
            locationVM.input = new LocationService();
            locationVM.dataObj = {
                value: "empty"
            };
            locationVM.getLookupName = LocationService.getLookupName;
            locationVM.getParentName = LocationService.getParentName;
            locationVM.Status = LocationService.Status;
            locationVM.gridColumns = angular.copy(LocationService.columns);
  
            locationVM.mainGridOptions = {
                dataSource: {
                    sort: [{
                        field: "status",
                        dir: "asc"
                    }],
                    transport: {
                        read: function(o) {
                            if(angular.isDefined(locationVM.searchClear) && locationVM.searchClear==false){
                                if(exists(locationVM.o)){
                                    copy(locationVM.o.data,["filter"],o.data);
                                }
                            }
                            locationVM.searchClear = false;
                            if(locationVM.onChildState()){return;}
                            if(!o.fromSideNav) {
                                if($state.searchClear){
                                    locationVM.searchClear = true;
                                    $state.searchClear=undefined;
                      //return;
                                }
                            }
                            else{
                                o.data.firstPage = true;
                            }

                            locationVM.o = angular.copy(o);
                            locationVM.filters = locationVM.o.data.filter;
                            LocationService.getByParams(o, true).then(function (response) {
                                locationVM.gridColumns[2].data = response.data;
                                for (var i = 0; i < response.data.length; i++) {

                  // if (response.data[i].LocationId == resolvedData.LoggedInUser.data.locationId) {
                  //     response.data[i].ParentLocationId = null;
                  // }
                                    if (response.data[i].LocationName == null)
                                        response.data[i].LocationName = "N/A";
                                    if (response.data[i].LocationCode == null)
                                        response.data[i].LocationCode = "N/A";
                                    if(response.data[i].ParentLocationId==null)
                                        response.data[i].ParentLocationId="N/A";
                                    if (response.data[i].LocationTypeLkpId == null)
                                        response.data[i].LocationTypeLkpId = "N/A";
                                    if (response.data[i].Status == null)
                                        response.data[i].Status = "N/A";
                                }
                                locationVM.container.locationTree.dataSource._data;
              // locationVM.gridData=response;
                                AddHasChildrenProperty(response);
                                if(locationVM.searchData!={})
                                    if(o.data.id == null) {
                                        FirstTimeLoadAddress(o);
                                    }
                                    else{
                                        ChildLoading(o , o.data.id)
                                    }
                            });
                        },
                        dataType: "application/json"
                    },
       //rowTemplate: "<tr data-uid='#= uid #'><td> \{\{dataItem.LocationCode\}\} </td><td> \{\{dataItem.ParentLocationId\}\}   </td><td>\{\{dataItem.LocationTypeLkpId\}\}   </td></tr>",
        // serverFiltering: true,
                    schema: {
                        data: "data",
                        total: "Total",
                        model: {
                            id: "LocationId",
                            parentId: "ParentLocationId",
                            fields: {
                                LocationId: {
                                    type: "number",
                                    editable: false,
                                    nullable: false
                                },
                                TenantId: {
                                    nullable: true,
                                    type: "number"
                                },
                                ParentLocationId: {
                                    nullable: true,
                                    type: "number"
                                },
                                ParentLocationName: {
                                    nullable: true,
                                    type: "string"
                                },
                                LocationCode: {
                                    nullable: true,
                                    type: "string"
                                },
                                LocationName: {
                                    nullable: true,
                                    type: "string"
                                },
                                LocationTypeLkpId: {
                                    nullable: true,
                                    type: "number"
                                },
                                status: {
                                    type: "string"
                                }
                            }
                        },

                        parse: function(response) {
                            response = response.data;
                            var products = [];
                            for (var i = 0; i < response.length; i++) {
                                var getParentName = LocationService.getParentName;
                                // eslint-disable-next-line no-unused-vars
                                var getStatus = function(EffectiveEndDate) {
                                    var currentDate = new Date();
                                    var endDate = kendo.parseDate(EffectiveEndDate);
                                    if ((endDate - currentDate) > 0)
                                        return 'Active';
                                    else
                                        return 'Inactive';
                                };
                                var Status = function(dataitem) {
                                    if (angular.isDefined(dataitem.EffectiveEndDate) && angular.isDefined(dataitem.EffectiveStartDate)) {
            //current date//
                                        var date = locationVM.date.split("T");
                                        date = date[0];
            //Start Date//
                                        if(angular.isObject(dataitem.EffectiveStartDate)){
                                            dataitem.EffectiveStartDate = dataitem.EffectiveStartDate.toJSON();
                                        }
                                        if(dataitem.EffectiveStartDate!="Invalid Date" && dataitem.EffectiveStartDate!=null){
                                            var startDate = dataitem.EffectiveStartDate.split("T");
                                            startDate = startDate[0];
                                        }
            //End Date//
                                        if(angular.isObject(dataitem.EffectiveEndDate)){
                                            dataitem.EffectiveEndDate = dataitem.EffectiveEndDate.toJSON();
                                        }
                                        if(dataitem.EffectiveEndDate!="Invalid Date" && dataitem.EffectiveEndDate!=null){
                                            var endDate = dataitem.EffectiveEndDate.split("T");
                                            endDate = endDate[0];
                                        }

                                        if (endDate >= date && startDate <= date) {
                                            return "Active";
                                        }
                                        else if(startDate > date){
                                            return "Pending";
                                        }
                                        else{
                                            return "Inactive";
                                        }
                                    }
                                    return 'Inactive';
                                };
                                var product = response[i];
                                product.LocationId = response[i].LocationId;
                                product.TenantId = response[i].TenantId;
                                product.ParentLocationId = response[i].ParentLocationId;
                                product.ParentLocationName = getParentName(response[i].ParentLocationId);
                                product.LocationCode = response[i].LocationCode;
                                product.LocationName = response[i].LocationName;
                                product.LocationTypeLkpId = response[i].LocationTypeLkpId;
                                product.status = Status(response[i]);
                                products.push(product);
                            }
                            products = {
                                data: products
                            };
                            return products;
                        }
                    },
                },
                pdf: {
                    allPages: true,
                    fileName: "Locations.pdf"
                },
                excel: {
/*        allPages: true,*/
                    fileName: "Locations.xlsx"
                },
                dataBound:onDataBound,
                sortable: true,
                resizable: true,
                scrollable: false,
                filterable: true,
                selectable:true,
                columns: locationVM.gridColumns

            };
            locationVM.bulk = [];
            locationVM.container = {};
            $state.data = {
                grid: locationVM.container,
                mainGridOptions: angular.copy(locationVM.mainGridOptions)
            };
            locationVM.searchSideNavActive = false;
            locationVM.exportSideNavActive = false;
            locationVM.searchDataObject = {
                page: 1,
                pageSize: 10,
                skip: 0,
                take: 10,
                sort: undefined,
                filter: locationVM.filt
            }
            locationVM.searchObject = {
                data: locationVM.searchDataObject
            };

            function onDataBound(arg) {

                if(locationVM.FilteredValue.LocationName==true || locationVM.FilteredValue.LocationCode==true || locationVM.FilteredValue.LocationTypeLkpId==true || locationVM.FilteredValue.ParentLocationId==true){
                    var kendoTree=arg.sender;
                    var dataItem=kendoTree.dataItems();
                    for(var i=0;i<dataItem.length;i++) {
                        if(dataItem[i].ParentLocationId!=null) {
                            var parent=findItems("LocationId",dataItem[i].ParentLocationId,dataItem)[0];
                            var parentRow = kendoTree.element.find("tr[data-uid=" + parent.uid + "]");
                            kendoTree.expand(parentRow);
                        }

                    }

                }
            }


            // eslint-disable-next-line no-unused-vars
            function setDisabled(e){
                var disabled=[];
                function addIfDisabled(item){
                    if(locationVM.isStatusActive(item))disabled.push(item);
                }
                e.sender.dataItems().forEach(addIfDisabled);
                function disableItem(item){
                    tmxUtility.applyClassOnRows(e.sender,"LocationId",item.LocationId,"deleted-row");
                }
                disabled.forEach(disableItem);
                locationVM.disabledItems=disabled;
            }

            // eslint-disable-next-line no-unused-vars
            function onExpand(e){
                $timeout(function(){onClick(e);},100);
            }
            // eslint-disable-next-line no-unused-vars
            function onCollapse(e){
                $timeout(function(){onClick(e);},100);
            }
            function onClick(e){

                function disableItem(item){
                    tmxUtility.applyClassOnRows(e.sender,"LocationId",item.LocationId,"deleted-row");
                }
                locationVM.disabledItems.forEach(disableItem);

                
            }
    ////////////////////////////////////////////////////


        }]);
})();
